import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import {
  SalaryComponent,
  TesSalaryComponentFilters,
  tesSalaryComponents,
} from "./tesSalaryComponentsAPI";

type Entities = {
  [key: string]: any;
};

export type SliceState = {
  ids: [];
  entities: Entities;
  status: "idle" | "pending" | "succeeded" | "failed";
  error?: string;
};

const tesSalaryComponentsAdapter = createEntityAdapter();

export const fetchTesSalaryComponents = createAsyncThunk<
  SalaryComponent[],
  TesSalaryComponentFilters,
  { state: RootState }
>(
  "tesSalaryComponents",
  async (filters: TesSalaryComponentFilters) =>
    await tesSalaryComponents(filters),
);

export const tesSalaryComponentsSlice = createSlice({
  name: "tesSalaryComponents",
  initialState: tesSalaryComponentsAdapter.getInitialState({
    status: "idle",
  }) as SliceState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTesSalaryComponents.pending, (state) => {
      state.status = "pending";
    });
    builder.addCase(fetchTesSalaryComponents.fulfilled, (state) => {
      state.status = "succeeded";
    });
    builder.addCase(fetchTesSalaryComponents.rejected, (state) => {
      state.status = "failed";
    });
  },
});

export const tesSalaryComponentsReducer = tesSalaryComponentsSlice.reducer;
